import SubscriptionsApi from 'api/subscriptions.api'
import { queryKeys } from 'queries/queryKeys'
import { useQuery } from 'react-query'

export const useSubscriptions = () => {
  const query = useQuery([queryKeys.SUBSCRIPTIONS], () => SubscriptionsApi.all(), { enabled: false, refetchOnWindowFocus: false })
  return query
}

